const _excluded = ["fieldName", "value", "onChange", "dataTestId", "id", "thousandSeparator", "decimalSeparator", "size", "style", "onlyPositiveNumbers", "showOverlay"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Form } from 'react-bootstrap';
import { ChangeHighlighter, FormattedNumberInput } from '..';
const DEFAULT_ID_PREFIX = 'decimal_form_field';
export function DecimalFormFieldRow(_ref) {
  let {
      fieldName,
      value,
      onChange = () => {},
      dataTestId,
      id: idProp,
      thousandSeparator = '.',
      decimalSeparator = ',',
      size = 'sm',
      style = {
        width: '100px'
      },
      onlyPositiveNumbers = true,
      showOverlay = true
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const id = idProp !== null && idProp !== void 0 ? idProp : "".concat(DEFAULT_ID_PREFIX, "_").concat(fieldName).replace(/\./g, '_');
  const testId = dataTestId !== null && dataTestId !== void 0 ? dataTestId : id;
  const fieldObject = {
    [fieldName]: value
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId,
    className: "DecimalFormFieldRow DecimalFormFieldRow-".concat(fieldName)
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, _extends({
    as: FormattedNumberInput,
    thousandSeparator: thousandSeparator,
    decimalSeparator: decimalSeparator,
    object: fieldObject,
    name: fieldName,
    type: "text",
    size: size,
    onlyPositiveNumbers: onlyPositiveNumbers,
    onChange: onChange,
    style: style,
    showOverlay: showOverlay,
    "data-testid": "".concat(testId, "-input")
  }, restProps)));
}